export default "__VITE_ASSET__9c4f7b0f__"